import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import Seo from '@/components/Seo';
import HomeScreenHint from '@/components/HomeScreenHint';
import { AUTH } from '@/constants/testIds';

export default function LoginPage() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) nav(next && next.startsWith('/') ? next : '/workspace');
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2">
      <Seo title="Log in" noindex />
      <div className="hidden lg:flex flex-col justify-between p-12 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 tm-tag-stripe opacity-10" />
        <div className="relative">
          <span className="font-display font-semibold tracking-tight text-2xl text-slate-900">Trades<em className="italic text-brand">Mate</em></span>
          <h2 className="mt-12 font-display font-semibold text-5xl uppercase tracking-tight leading-[0.95]">Welcome back.<br/><span className="text-brand">Back on the tools.</span></h2>
          <p className="mt-6 text-slate-300 max-w-md">Sign in to access your saved quotes, calculators and the AI estimator.</p>
        </div>
        <p className="relative text-xs uppercase tracking-widest text-slate-400 font-semibold">© TradesMate UK</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="tm-card p-8 w-full max-w-md space-y-5">
          <h1 className="font-display font-semibold text-3xl uppercase tracking-tight">Log in</h1>
          <p className="text-sm text-slate-600 -mt-3">Use your TradesMate account.</p>
          <HomeScreenHint />
          <div>
            <label className="tm-label">Email</label>
            <input data-testid={AUTH.loginEmail} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="tm-input" placeholder="you@trade.co.uk"/>
          </div>
          <div>
            <label className="tm-label">Password</label>
            <input data-testid={AUTH.loginPassword} type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="tm-input" placeholder="••••••••"/>
            <Link to="/forgot-password" data-testid="forgot-password-link" className="inline-block mt-2 text-xs font-bold text-slate-500 hover:text-brand underline underline-offset-2">Forgot your password?</Link>
          </div>
          {error && <p className="text-sm font-mono text-red-600 bg-red-50 border border-red-600 p-2">{error}</p>}
          <button data-testid={AUTH.loginSubmit} disabled={busy} className="tm-btn w-full">
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
          <p className="text-sm text-slate-600">
            New to TradesMate?{' '}
            <Link to="/register" data-testid={AUTH.switchToRegister} className="underline underline-offset-4 font-bold text-slate-900 hover:text-brand">Create account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
